<script setup>
import { defineProps, defineEmits } from 'vue';

defineProps({
  showingOriginal: Boolean,
  originalLanguage: { type: String, default: null },
  translatedLanguage: { type: String, default: null },
  isTranslating: { type: Boolean, default: false },
});

defineEmits(['toggle']);

const getLanguageName = (code) => {
  const languages = {
    'en': 'English', 'es': 'Spanish', 'fr': 'French', 'de': 'German',
    'it': 'Italian', 'pt': 'Portuguese', 'nl': 'Dutch', 'pl': 'Polish',
    'ru': 'Russian', 'ja': 'Japanese', 'zh': 'Chinese', 'ko': 'Korean',
    'ar': 'Arabic', 'hi': 'Hindi', 'tr': 'Turkish', 'vi': 'Vietnamese',
    'th': 'Thai', 'sv': 'Swedish', 'no': 'Norwegian', 'da': 'Danish',
    'fi': 'Finnish', 'cs': 'Czech', 'el': 'Greek', 'he': 'Hebrew',
    'id': 'Indonesian', 'ms': 'Malay', 'ro': 'Romanian', 'uk': 'Ukrainian',
    'bg': 'Bulgarian', 'hr': 'Croatian', 'sk': 'Slovak', 'sl': 'Slovenian',
    'lt': 'Lithuanian', 'lv': 'Latvian', 'et': 'Estonian'
  };
  return languages[code] || code?.toUpperCase();
};
</script>

<template>
  <div class="flex items-center gap-2 mt-1">
    <!-- Language badges -->
    <div v-if="originalLanguage || translatedLanguage" class="flex items-center gap-1.5 text-xs">
      <span v-if="originalLanguage" class="px-2 py-0.5 rounded bg-n-alpha-2 text-n-slate-11 font-medium">
        {{ getLanguageName(originalLanguage) }}
      </span>
      <span v-if="originalLanguage && translatedLanguage" class="text-n-slate-10">→</span>
      <span v-if="translatedLanguage" class="px-2 py-0.5 rounded bg-n-brand/10 text-n-brand font-medium">
        {{ getLanguageName(translatedLanguage) }}
      </span>
    </div>

    <!-- Toggle button -->
    <span
      class="text-xs text-n-slate-11 cursor-pointer hover:underline select-none flex items-center gap-1"
      @click="$emit('toggle')"
    >
      <span v-if="isTranslating" class="i-lucide-loader-2 animate-spin size-3" />
      {{
        showingOriginal
          ? $t('CONVERSATION.VIEW_TRANSLATED')
          : $t('CONVERSATION.VIEW_ORIGINAL')
      }}
    </span>
  </div>
</template>
